import request from "superagent";
import { getAuthHeader } from "src/utils/superagent";
import { uploadFacilityImageFss } from "src/utils/fileUpload";

export enum PhotoStatus {
  DONE = "done",
  UPLOADING = "uploading",
  REMOVED = "removed",
}

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'url' implicitly has an 'any' type.
export const removeAspectRatio = (url) => {
  const index = url.indexOf("/ar_1.33333333,c_crop");
  const index2 = url.indexOf("/v");
  if (!index || index < 0) {
    return url;
  }
  if (!index2 || index2 < 0) {
    return url;
  }
  return url.substring(0, index) + url.substring(index2, url.length);
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'photosList' implicitly has an 'any' type.
const transformPhotosListData = (photosList) => {
  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'ph' implicitly has an 'any' type.
  photosList.forEach((ph) => {
    ph.uid = `${ph.index}`;
    ph.name = ph.name || ph.url.substring(ph.url.lastIndexOf("/") + 1);
    ph.status = PhotoStatus.DONE;
  });
};

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'facilityId' implicitly has an 'any' type.
export const getFacilityPhotos = async ({ facilityId }) => {
  const resp = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/facilityProfile/photos/${facilityId}`)
    .set(await getAuthHeader());

  let photosList = [];
  if (resp.body?.photosList) {
    photosList = resp.body.photosList;
    transformPhotosListData(photosList);
  }
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  photosList.sort((a: any, b: any) => {
    if (a.index < b.index) {
      return -1;
    }
    if (a.index > b.index) {
      return 1;
    }
    return 0;
  });
  return photosList;
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'facilityId' implicitly has an 'any' type.
export const uploadFacilityImage = async (facilityId, filteredNewPhotos) => {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fileUploadList: any[] = [];

  for (const photo of filteredNewPhotos) {
    const body = await uploadFacilityImageFss(facilityId, photo.originFileObj);

    photo.fileStorageRootFolder = body.folderName;
    photo.fileStorageFileKey = body.fileKey;
    fileUploadList.push(photo);
  }

  return fileUploadList;
};

export const writeReferenceToFacilityImage = async ({
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'facilityId' implicitly has an 'any' type.
  facilityId,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'updatedReference' implicitly has an 'any' type.
  updatedReference,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'filesToDelete' implicitly has an 'any' type.
  filesToDelete,
}): Promise<void> => {
  await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .put(`${global.api}/facilityProfile/photos/${facilityId}`)
    .set(await getAuthHeader())
    .send({ updatedReference, filesToDelete });
};
